import React from "react";
import { FormSection, FormSectionProps } from "@emisgroup/ui-form";

interface CustomFormSectionProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

type FrmSecProps = FormSectionProps & CustomFormSectionProps;

/**
 * Responsible for rendering the form section
 * @returns form section and its elements
 */
export const UIFormSection: React.FC<FrmSecProps> = (props: FrmSecProps) => {
  const { children } = props;
  return (
    <FormSection
      {...props}
    >
      {children}
    </FormSection>
  );
};
